import type {RouteRecordRaw} from "vue-router";

import IconIncoming from '@/shared/ui/icons/document/Incoming.vue';

import {route as listRoute, routeName as listRouteName} from './list';
import {route as docRoute} from './doc';

export const routeName = 'Incoming';

export const route: RouteRecordRaw = {
    name: routeName,
    path: 'incoming',
    redirect: {
        name: listRouteName,
    },
    children: [
        docRoute,
        listRoute,
    ],
    meta: {
        title: 'incoming',
        icon: IconIncoming,
        isNavTab: true,
    }
};
